module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.vehicle) ? _c('div', {
    staticClass: "component-tabbed-vehicle-map-position"
  }, [_c('div', {
    staticClass: "action-bar"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("Vehicle Position " + _vm._s(_vm.vehicle.vehicle_slot_address) + "  " + _vm._s(_vm.vehicle.has_reservation ? ' - ' + _vm.vehicle.has_reservation : ''))])])]), _c('div', {
    staticClass: "wrap"
  }, [_c('GoogleMapContainer', [_c('GoogleMap', {
    attrs: {
      "center": {
        lat: _vm.vehicle.position.latitude,
        lng: _vm.vehicle.position.longitude
      },
      "api-key": _vm.mapsAPI,
      "searchBar": true,
      "zoom": 17,
      "zoomControl": true,
      "mapTypeControl": true
    }
  }, [(_vm.zones.allowed) ? _c('div', _vm._l((_vm.zones.allowed.poly), function(allowed) {
    return _c('google-map-polygon', {
      attrs: {
        "positions": allowed,
        "color": "green",
        "fillColor": "green"
      }
    })
  }), 1) : _vm._e(), (_vm.zones.forbidden) ? _c('div', _vm._l((_vm.zones.forbidden.poly), function(forbidden) {
    return (_vm.zones.forbidden !== null) ? _c('google-map-polygon', {
      attrs: {
        "positions": forbidden
      }
    }) : _vm._e()
  }), 1) : _vm._e(), (_vm.zones.undesiderable) ? _c('div', [_vm._l((_vm.zones.undesiderable.poly), function(undesiderable) {
    return (_vm.zones.undesiderable) ? _c('google-map-polygon', {
      attrs: {
        "positions": undesiderable,
        "color": "yellow",
        "fillColor": "yellow"
      }
    }) : _vm._e()
  }), _c('GoogleMapPolygon')], 2) : _vm._e(), _c('GoogleMapMarker', {
    attrs: {
      "position": {
        lat: _vm.vehicle.position.latitude,
        lng: _vm.vehicle.position.longitude
      },
      "title": _vm.vehicle.model,
      "label": _vm.vehicle.model,
      "icon": _vm.vehicleInRange(_vm.vehicle)
    }
  }), _c('GoogleMapCircle', {
    attrs: {
      "position": {
        lat: _vm.vehicle.parking_lot.position.latitude,
        lng: _vm.vehicle.parking_lot.position.longitude
      }
    }
  })], 1)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00458155!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/VehicleMapPosition.vue
// module id = 2213
// module chunks = 1